module.exports = __webpack_public_path__ + "img/close_modal.44852e6d.svg";